module.exports = __webpack_public_path__ + "img/icon_treasureChest_closed.5857485.png";